import { createActionWithPayload, IActionWithPayload } from '../utils';
import { ICommonSettings } from './settings';

const COMMON_SETTINGS_SET = 'COMMON_SETTINGS/SET';

export interface CommonSettingsState {
  commonSettings?: ICommonSettings;
}

type SetCommonSettingsActionType = IActionWithPayload<
  typeof COMMON_SETTINGS_SET,
  ICommonSettings
>;

type Actions = SetCommonSettingsActionType;

const initialState: CommonSettingsState = {
  commonSettings: undefined,
};

export const setCommonSettingsAction = (settings: ICommonSettings) => {
  return createActionWithPayload(COMMON_SETTINGS_SET, settings);
};

// reducer
export const commonSettingsReducer = (
  state: CommonSettingsState = initialState,
  action: Actions
): CommonSettingsState => {
  switch (action.type) {
    case COMMON_SETTINGS_SET:
      return {
        ...state,
        commonSettings: action.payload,
      };
    default:
      return state;
  }
};

